"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var connect_1 = require("./connect");
exports.connect = connect_1.default;
var Provider_1 = require("./Provider");
exports.Provider = Provider_1.default;
//# sourceMappingURL=index.js.map